const InitialState = {
  instructorCoursesMap: null,
  instructorImportCoursesList: [],
  studentCoursesMap: [],
  publicCoursesMap: [],
  instituteList: [],
  departmentList: [],
  paginationInfo: null,

  studentCourseGroupsMap: {},
  studentGroupConceptsMap: {},
  instructorCourseGC: {
    instructorCourseGroupsMap: {},
    instructorGroupConceptsMap: {},
  },
  otherLabs: [],
  labs: {
    access_control_vars: {},
    labs: [],
  },
  instructorConceptDataMap: {},
  studentConceptDataMap: {},
  userInfo: {
    loading: false,
    username: null,
    email: null,
    token: null,
    expirationDate: null,
    error: null,
    msg: null,
    mode: null,
  },
  userCourseRole: null,
  forum: {},
  scheduleList: [],
  studentprogramming: new Map(),
  instructorProgramming: new Map(),
  issues: new Map(),
  studentGrades: {
    loading: false,
    tableData: [],
  },
  fileUploadProgress: {
    uploadProgress: '',
    uploadRequestStatus: '',
  }
};
export default InitialState;
